module.exports = __webpack_public_path__ + "8d9624dcaef931856175988872b03a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/L@2x.png
// module id = 837
// module chunks = 0